import React, { useCallback, useEffect, useState } from 'react';


import DataTable from "../../components/DataTable";
import * as TableStyle from "../../components/DataTable/style";
import BreadCrumbNavigation from "../../components/DataTable/TopSection/BreadCrumbNavigation";
import HeaderWithAction from "../../components/DataTable/TopSection/HeaderWithAction";
import api from '../../services/api';
import * as S from './style';

function LockAccountList() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fieldsToFormat = [
    'sistema', 
    'permitirAlterarLimite', 
    'cancelaCliente', 
    'bloquearModuloCliente'
  ];

  const tableHeadersAndFilters =  [
    {descricao: "Descrição", filterType: 'text'},
    {sistema: "Sistema", filterType: 'uniqueData', options: {Sim: 0, Não: 0}},
    {permitirAlterarLimite: "Altera Limite", filterType: 'uniqueData', options: {Sim: 0, Não: 0}},
    {bloquearModuloCliente: "Bloqueia Módulo Cliente", filterType: 'uniqueData', options: {Sim: 0, Não: 0}},
    {cancelaCliente: "Cancela", filterType: 'uniqueData', options: {Sim: 0, Não: 0}},
  ];

  const fetchLockList = useCallback(async () => {

    try {
      setLoading(true);
      const { data } = await api.get('list_lock_account');

      const formattedData = data.map(item => {
        const newItem = { ...item };
        
        fieldsToFormat.forEach(key => {
          newItem[key] = newItem[key] ? "SIM" : "NÃO";
        });
        
        return newItem;
      });

      setData(formattedData);
    } catch (err) {
      console.error('Erro ao listar tipos de bloqueio de conta')
    } finally {
      await setLoading(false);
    }
  }, []);

  useEffect(async () => {
    await fetchLockList();
  }, [fetchLockList]);

  return (
    <>
      <S.Container data-testid="lock-account-list-page">
        <BreadCrumbNavigation tableName="Tipos de bloqueio de conta" preTableName='Listagens'   />
            <TableStyle.Content>
              <HeaderWithAction
                tableName="Tipos de bloqueio de conta" />
              {data && (
                  <DataTable
                    data={data}
                    loading={loading}
                    tableName="Tipos de bloqueios de conta"
                    tableHeadersAndFilters={tableHeadersAndFilters}
                  />
              )}
            </TableStyle.Content>
      </S.Container>
    </>
  );
}
export default React.memo(LockAccountList);
